import { Grid } from '@mui/material';
import { SimpleShowLayout, TextField } from 'react-admin';
import { AccountHolderAddress } from 'src/models';

interface AddressDetailsProps {
  record: AccountHolderAddress;
}

export const AddressDetails = ({ record }: AddressDetailsProps) => {
  return (
    <Grid container direction='row' spacing={2}>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='address1' label='Street Address (Line 1)' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='address2' label='Street Address (Line 2)' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='city' label='City' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='state.label' label='State' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='country.label' label='Country' />
        </SimpleShowLayout>
      </Grid>
      <Grid item md={6}>
        <SimpleShowLayout>
          <TextField record={record} source='postalCode' label='Postal Code' />
        </SimpleShowLayout>
      </Grid>
    </Grid>
  );
};
